import { render } from "./twoPage.vue?vue&type=template&id=6d8b9c41&scoped=true"
import script from "./twoPage.vue?vue&type=script&lang=js"
export * from "./twoPage.vue?vue&type=script&lang=js"

import "./twoPage.vue?vue&type=style&index=0&id=6d8b9c41&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8b9c41"]])

export default __exports__